/* tslint:disable */
/* eslint-disable */
export enum AppUserType {
  Personal = 'PERSONAL',
  Business = 'BUSINESS'
}
